class SlideShowHome {

    constructor (container) {
        this.container         = container
        this.nodes             = Array.from(document.querySelectorAll('.slideshow-item'))
        this.control           = container.querySelector('.slideshow-control')
        this.controllers       = Array.from(document.querySelectorAll('.slideshow-controller'))
        this.currentNode       = this.nodes[0]
        this.currentController = this.controllers[0]
        this.amount            = 0
        this.interval          = undefined
        this.timing            = 4000
    }

    init() {
        this.launcher()
        this.control.addEventListener('click', this.handleClick.bind(this))
    }

    handleClick(e) {
        let el = e.target

        if (el.classList.contains('slideshow-controller'))
            return this.resetLauncher(el)
    }

    launcher() {
        this.interval = window.setInterval(this.getNextSlide.bind(this), this.timing)
    }

    resetLauncher(el) {
        if (el.classList.contains('trigger')) return 

        clearInterval(this.interval)
        
        this.currentNode.setAttribute('aria-hidden', 'true')
        this.currentNode.classList.remove('trigger')
        this.currentController.setAttribute('aria-selected', 'false')
        this.currentController.classList.remove('trigger')

        this.amount = this.controllers.indexOf(el)

        this.currentNode = this.nodes[this.amount]
        this.currentController = this.controllers[this.amount]

        
        this.currentNode.setAttribute('aria-hidden', 'false')
        this.currentController.setAttribute('aria-selected', 'false')
        this.currentNode.classList.add('trigger')
        this.currentController.classList.add('trigger')

        return this.launcher()
    }

    getNextSlide() {
        this.currentNode.setAttribute('aria-hidden', 'true')
        this.currentNode.classList.remove('trigger')
        this.currentController.setAttribute('aria-selected', 'false')
        this.currentController.classList.remove('trigger')


        this.amount++
        
        if (this.amount === this.controllers.length || this.amount > this.controllers.length)
            this.amount = 0 

        this.currentNode = this.nodes[this.amount]
        this.currentController = this.controllers[this.amount]

        
        this.currentNode.setAttribute('aria-hidden', 'false')
        this.currentController.setAttribute('aria-selected', 'false')
        this.currentNode.classList.add('trigger')
        this.currentController.classList.add('trigger')
    }
}

class SlideShowTouch {

    constructor (container) {
        this.container   = container
        this.nodes       = container.children
        this.nodesLng    = container.children.length
        this.clientWidth = container.clientWidth
        this.touchStartX = undefined
        this.touchMoveX  = undefined
        this.moveX       = undefined
        this.index       = 0
        this.longTouch   = false
    }

    init() {
        if (window.matchMedia('(min-width: 1024px)').matches) 
            return this.container.style.transform = ''
        
        this.bindUIEvents()
    }

    bindUIEvents() {
        this.container.addEventListener('touchstart', this.touchStart.bind(this))
        this.container.addEventListener('touchmove', this.touchMove.bind(this))
        this.container.addEventListener('touchend', this.touchEnd.bind(this))
    }

    touchStart(e) {

        if (window.matchMedia('(min-width: 1024px)').matches) return

        this.touchStartX = e.touches[0].pageX
    }

    touchMove(e) {

        if (window.matchMedia('(min-width: 1024px)').matches) return

        this.touchMoveX = e.touches[0].pageX
        this.moveX = (this.index * this.clientWidth + (this.touchStartX - this.touchMoveX))

        let state = this.touchStartX - this.touchMoveX,
            translate = this.nodes[0].clientWidth * this.index,
            nodeClientWidth = this.nodes[0].clientWidth,
            maxSize         = nodeClientWidth - (nodeClientWidth / 3)

        if (state < maxSize && state > -maxSize)
            this.container.style.transform = 'translate3d(' + (-translate - state) + 'px, 0, 0)'
    }

    touchEnd() {
        console.log(this.longTouch)

        if (window.matchMedia('(min-width: 1024px)').matches) return

        let absMove   = Math.abs(this.index * this.clientWidth - this.moveX),
            translate = -this.nodes[0].clientWidth
        
        
        if (absMove > (this.clientWidth / 2)) {
            if (this.moveX > this.index * this.clientWidth && this.index < (this.nodesLng - 1))
                this.index++
            else if (this.moveX < this.index * this.clientWidth && this.index > 0) {
                this.index--
            }
        }

        this.container.style.transform = 'translate3d(' + (this.index * translate - 20 * this.index) + 'px, 0, 0)'
    }
}

const slideShowArrow = (el) => {
    
    let direction         = (el.classList.contains('previous')) ? -1 : 1,
        nodes             = Array.from(document.querySelectorAll('.slideshow__history__slide')),
        current           = document.querySelector('.slideshow__history__slide.trigger'),
        index             = nodes.indexOf(current),
        currentController = document.querySelector('.slideshow__history__controller.trigger')

    index = index + direction
    current.classList.remove('trigger')
    nodes[index].classList.add('trigger')

    if (currentController && currentController !== el)
        currentController.classList.remove('trigger')

    if (index === nodes.length - 1 || index === 0)
        el.classList.add('trigger')

}



export {
    SlideShowHome,
    SlideShowTouch,
    slideShowArrow
}